import 'swiper/css'
import store from "../store"
import AssetLoader from "./assetLoader"

export default {

	init: function() {
    const t = this
    
    if(store.getState().sniffer.isIE11) {
      return false
    }
    
    const sliderDataAttr = '[data-slider]'
    
    if(document.querySelectorAll(sliderDataAttr).length > 0) {
      const swiper = new AssetLoader(sliderDataAttr, 'https://unpkg.com/swiper@7/swiper-bundle.min.js')

      swiper.onLoad = () => {
        t.sliders = document.querySelectorAll( sliderDataAttr )

        if (! t.sliders) return

        Array.from(t.sliders).forEach((slider) => {
          if(slider.getAttribute('data-slider-type') == 'project') {
            t.initSliderProject(slider)
          } else if(slider.getAttribute('data-slider-type') == 'portfolio') {
            t.initSliderPortfolio(slider)
          }
        })
        
      }
    }
  },

  initSliderProject: function(slider) {
    const t = this

    let options = {
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      allowTouchMove: false,
    }
    t.initSlider(slider, options)
  },
  
  initSliderPortfolio: function(slider) {
    const t = this

    let options = {
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      allowTouchMove: false,
      slidesPerView: 1,
      loop: true,
      breakpoints: {
        1024: {
          slidesPerView: 1.5,
        }
    }
    }
    t.initSlider(slider, options)
  },
  
  initSlider: function(slider, options) {
    new Swiper(slider, options)
  }
}